import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { TournamentService } from '@/modules/tournament/api/services'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import type { paths } from '@/schema'

type UpdateTournamentBody =
	paths['/api/admin/tournaments/{id}']['patch']['requestBody']['content']['application/json']
type UpdateTournamentResponse =
	paths['/api/admin/tournaments/{id}']['patch']['responses']['200']['content']['application/json']

interface UseMutationUpdateTournamentOptions {
	onSuccess?: () => void
	onError?: (error: Error) => void
}

const useMutationUpdateTournament = (
	id: string,
	options?: UseMutationUpdateTournamentOptions,
) => {
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	return useMutation<UpdateTournamentResponse, Error, UpdateTournamentBody>({
		mutationFn: (body) => TournamentService.updateTournament(id, body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL,
			})
			toast.success('อัปเดตทัวร์นาเมนต์สำเร็จ')
			if (options?.onSuccess) {
				options.onSuccess()
			} else {
				navigate('/operator/tournaments')
			}
		},
		onError: (error) => {
			toast.error('อัปเดตทัวร์นาเมนต์ล้มเหลว')
			options?.onError?.(error)
		},
	})
}

export default useMutationUpdateTournament
